/*
 * Copyright (c) 2025 Bytedance, Inc. and its affiliates.
 * SPDX-License-Identifier: Apache-2.0
 */

import Agent from '@tarko/agent';

/**
 * @abstract
 * @class BaseGUIAgent
 * @classdesc Abstract base class for GUI Agents.
 */
export abstract class BaseGUIAgent extends Agent {}
